import React, { useState } from 'react';
import {
  MapSnapshotButton,
  MoreOptionsToggleButton,
  TerrainToggleButton,
  ZoningToggleButton,
} from './control-buttons';
import {
  mapSnapshotCallback,
  toggleZoningLayerOpacity,
} from './ctrl-button-cbs';
import { HiddenUntilToggledWrapper } from './map-control-styles';

function HideableLayerCtrls(props) {
  const { layerCtrlsOpen, setLayerCtrlsOpen, hasZoningFile } = props;
  return (
    <>
      <HiddenUntilToggledWrapper
        className="mapboxgl-ctrl mapboxgl-ctrl-group"
        layerCtrlsOpen={layerCtrlsOpen}
      >
        <TerrainToggleButton
          layerCtrlsOpen={layerCtrlsOpen}
          hasZoningFile={hasZoningFile}
        />
        <ZoningToggleButton
          onClick={() => toggleZoningLayerOpacity(hasZoningFile)}
        />
      </HiddenUntilToggledWrapper>
      <MoreOptionsToggleButton
        onClick={() => setLayerCtrlsOpen(!layerCtrlsOpen)}
        layerCtrlsOpen={layerCtrlsOpen}
      />
    </>
  );
}

export function MapLayerCtrlGroup(props) {
  const { map } = props;
  const [layerCtrlsOpen, setLayerCtrlsOpen] = useState(false);
  const FIRST_ZONING_FILE_SOURCE_ID = 'SOURCES.ZONING_FILE_0';
  const hasZoningFile = map.getSource(FIRST_ZONING_FILE_SOURCE_ID);

  // TODO: Improve this. We need a visibility Mgr for in a Container component for readability
  const LayerCtrls = hasZoningFile ? HideableLayerCtrls : TerrainToggleButton;

  return (
    <div>
      <LayerCtrls
        map={map}
        layerCtrlsOpen={hasZoningFile ? layerCtrlsOpen : true}
        setLayerCtrlsOpen={setLayerCtrlsOpen}
        hasZoningFile={hasZoningFile}
        onClick={(setCurrentStyle) =>
          mapStyleToggleButtonCallback(setCurrentStyle)
        }
      />
      <MapSnapshotButton onClick={() => mapSnapshotCallback(map)} />
    </div>
  );
}
